import React, { FC, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import NotificationAlert from "react-notification-alert";

import { get_accounts } from "stores/Accounts/actions";
import {
  get_wallets,
  get_markets_rates,
  get_histories_orderings,
  get_histories_orders,
  get_histories_transactions,
} from "stores/Service/actions";
import { getMessage } from "config/util";

const App = ({}) => {
  const reduce_post_authin = useSelector((state) => state.reduce_post_authin);

  const dispatch = useDispatch();
  const ref = useRef();

  const toast = (error) => {
    const message = getMessage(error);
    dispatch_danger(message);
  };

  const dispatch_danger = (message) => {
    if (ref.current) {
      var options = {};
      options = {
        place: "tc",
        message: (
          <div>
            <span data-notify="icon" className="nc-icon nc-single-copy-04" />
            <span>{message}</span>
          </div>
        ),
        type: "danger",
        icon: "now-ui-icons ui-1_bell-53",
        autoDismiss: 5,
      };
      ref.current.notificationAlert(options);
    }
  };

  const dispatch_get_markets_rates = (data, page) => {
    dispatch(
      get_markets_rates({
        data,
        toast,
        page,
      })
    );
  };

  const dispatch_get_wallets = (data, page) => {
    dispatch(
      get_wallets({
        data,
        toast,
        page,
      })
    );
  };

  const dispatch_get_accounts = (data, page) => {
    dispatch(
      get_accounts({
        data,
        toast,
        page,
      })
    );
  };

  const dispatch_get_histories_orderings = (data, page) => {
    dispatch(
      get_histories_orderings({
        data,
        toast,
        page,
      })
    );
  };

  const dispatch_get_histories_orders = (data, page) => {
    dispatch(
      get_histories_orders({
        data,
        toast,
        page,
      })
    );
  };
  const dispatch_get_histories_transactions = (data, page) => {
    dispatch(
      get_histories_transactions({
        data,
        toast,
        page,
      })
    );
  };

  useEffect(() => {
    dispatch_get_accounts({}, () => {});
    dispatch_get_markets_rates({}, () => {});
    dispatch_get_wallets({}, () => {});
    dispatch_get_histories_orderings({ page: 1, limit: 10 });
    dispatch_get_histories_orders({ page: 1, limit: 10 });
    dispatch_get_histories_transactions({ page: 1, limit: 10 });
  }, [reduce_post_authin.token]);

  return (
    <>
      <div className="notification-container">
        <NotificationAlert ref={ref} />
      </div>
    </>
  );
};

export default App;
